module.exports = __webpack_public_path__ + "img/qiyphz.9167ff28.png";